import { cn } from '@/lib/utils';
import './Spinner.css';

export interface SpinnerProps {
  /** Diameter in px. Defaults to 16 (inline with text). */
  size?: number;
  className?: string;
  /** Accessible label; omit when the spinner is decorative beside visible text. */
  label?: string;
}

/**
 * Indeterminate progress ring. Kept functional under reduced motion (it slows,
 * never freezes) per the motion guidance. Inside content prefer Skeleton.
 */
export function Spinner({ size = 16, className, label }: SpinnerProps): JSX.Element {
  return (
    <span
      className={cn('spinner', className)}
      style={{ width: size, height: size }}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
